import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData, sort } from './utils';
let DemoSortable = class DemoSortable extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.filteredList = [];
        this.sortType = 'none';
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column .sort=${this.sortType} @sortChange=${e => this.sortType = e.detail}>
          Stock
        </cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.filteredList.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateList();
    }
    updated(props) {
        super.updated(props);
        if (props.has('sortType') && props.get('sortType') !== this.sortType) {
            this.updateList();
        }
    }
    updateList() {
        this.filteredList = sort([...this.data], 'id', this.sortType);
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoSortable.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoSortable.prototype, "filteredList", void 0);
__decorate([
    internalProperty()
], DemoSortable.prototype, "sortType", void 0);
DemoSortable = __decorate([
    customElement('demo-sortable')
], DemoSortable);
export { DemoSortable };
//# sourceMappingURL=demo.column-sortable.js.map